const EXPLANATION_TEXT_FIELDS = Object.freeze([
  'whatHappens',
  'whyItMayHappen',
  'whatTeamIsDoing',
  'variationNote',
]);

function cleanText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function normalizeNextStep(step, index) {
  if (typeof step === 'string') {
    const title = cleanText(step);
    return title ? { id: `next-${index + 1}`, title } : null;
  }
  if (!step || typeof step !== 'object' || Array.isArray(step)) return null;

  const title = cleanText(step.title);
  if (!title) return null;

  const normalized = {
    id: cleanText(step.id) || `next-${index + 1}`,
    title,
  };
  const description = cleanText(step.description);
  const when = cleanText(step.when);
  const stageId = cleanText(step.stageId);
  if (description) normalized.description = description;
  if (when) normalized.when = when;
  if (stageId) normalized.stageId = stageId;
  return normalized;
}

export function normalizeJourneyStageExplanation(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;

  const normalized = {};
  for (const field of EXPLANATION_TEXT_FIELDS) {
    const text = cleanText(value[field]);
    if (text) normalized[field] = text;
  }

  const nextSteps = Array.isArray(value.nextSteps)
    ? value.nextSteps.map(normalizeNextStep).filter(Boolean)
    : [];
  if (nextSteps.length) normalized.nextSteps = nextSteps;

  return Object.keys(normalized).length ? normalized : null;
}

export function normalizeJourneyStage(stage = {}) {
  const explanation = normalizeJourneyStageExplanation(stage.explanation);
  const roleIds = Array.isArray(stage.roleIds)
    ? [...new Set(stage.roleIds.map(cleanText).filter(Boolean))]
    : [];

  return {
    ...stage,
    ...(explanation ? { explanation } : {}),
    ...(roleIds.length ? { roleIds } : {}),
  };
}

export function validateJourneyStageExplanation(stage = {}, knownStageIds = []) {
  const errors = [];
  const explanation = normalizeJourneyStageExplanation(stage.explanation);
  if (stage.explanation && !explanation) errors.push('explanation must contain patient-facing content');

  const known = new Set(knownStageIds);
  for (const step of explanation?.nextSteps || []) {
    if (step.stageId && known.size && !known.has(step.stageId)) {
      errors.push(`next step ${step.id} references unknown stage ${step.stageId}`);
    }
  }

  const roleIds = Array.isArray(stage.roleIds) ? stage.roleIds : [];
  if (roleIds.some((id) => !cleanText(id))) errors.push('roleIds must contain non-empty role identifiers');
  if (new Set(roleIds.map(cleanText)).size !== roleIds.length) errors.push('roleIds must not contain duplicates');

  return errors;
}

export { EXPLANATION_TEXT_FIELDS as JOURNEY_STAGE_EXPLANATION_TEXT_FIELDS };
